import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import franchiseService from '../services/franchiseService'
import { toast } from 'react-hot-toast'
import './Franchise.css'

const Franchise = () => {
  const [franchises, setFranchises] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [searchParams] = useSearchParams()
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    businessName: '',
    location: '',
    address: '',
    pincode: '',
    village_name: '',
    mandal_name: '',
    city_name: '',
    state: '',
    message: '',
    interest: 'tags'
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const interest = searchParams.get('interest')
    if (interest) {
      setFormData(prev => ({
        ...prev,
        interest: interest === 'tags' ? 'tags' : 'restaurant'
      }))
      setShowForm(true) // Auto open form if link is used
    }
  }, [searchParams])

  const handleChange = (e) => {
    const { name } = e.target
    let { value } = e.target

    if (name === 'phone') {
      value = value.replace(/\D/g, '').slice(0, 10)
    }

    if (name === 'pincode') {
      value = value.replace(/\D/g, '').slice(0, 6)
    }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const validateForm = () => {
    if (!formData.name.trim()) {
      toast.error('Full name is required')
      return false
    }

    if (!/^\d{10}$/.test(formData.phone)) {
      toast.error('Phone number must be exactly 10 digits')
      return false
    }

    if (!formData.businessName.trim()) {
      toast.error('Business name is required')
      return false
    }

    if (!formData.address.trim()) {
      toast.error('Address is required')
      return false
    }

    if (!formData.city_name.trim()) {
      toast.error('City name is required')
      return false
    }

    if (!formData.state.trim()) {
      toast.error('State is required')
      return false
    }

    if (!formData.mandal_name.trim()) {
      toast.error('Mandal name is required')
      return false
    }

    if (!/^\d{6}$/.test(formData.pincode)) {
      toast.error('Pincode must be exactly 6 digits')
      return false
    }

    return true
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validateForm()) return
    setLoading(true)
    try {
      // Append interest to message for admin visibility
      const submissionData = {
        ...formData,
        name: formData.name.trim(),
        email: formData.email.trim(),
        businessName: formData.businessName.trim(),
        location: formData.location.trim(),
        address: formData.address.trim(),
        village_name: formData.village_name.trim(),
        mandal_name: formData.mandal_name.trim(),
        city_name: formData.city_name.trim(),
        state: formData.state.trim(),
        message: `[Interest: ${formData.interest === 'tags' ? 'Tag Distributor' : 'Restaurant Franchise'}]\n${formData.message.trim()}`
      }

      await franchiseService.createRequest(submissionData)
      toast.success('Application submitted successfully! We will contact you soon.')
      setFormData({
        name: '',
        email: '',
        phone: '',
        businessName: '',
        location: '',
        address: '',
        pincode: '',
        village_name: '',
        mandal_name: '',
        city_name: '',
        state: '',
        message: '',
        interest: 'tags'
      })
      setShowForm(false)
    } catch (error) {
      console.error(error)
      toast.error(error.message || 'Failed to submit application')
    } finally {
      setLoading(false)
    }
  }

  const isTagInterest = formData.interest === 'tags'

  return (
    <div className="container">
      <div className="page-header">
        <div>
          <h1>{isTagInterest ? 'Tag Distributor Program' : 'Franchise Management'}</h1>
          <p className="page-subtitle">
            {isTagInterest 
              ? 'Become a partner in our vehicle safety network'
              : 'Explore and manage franchise locations'
            }
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h2 className="card-title">
            {isTagInterest ? 'Apply for Tag Distributorship' : 'Become a Franchise Partner'}
          </h2>
          <p className="card-subtitle">
            {isTagInterest
              ? 'Join us in distributing smart QR tags for vehicle safety.'
              : 'Join our growing network of franchise partners and expand your business with NAH44.'
            }
          </p>
        </div>
        
        {!showForm ? (
          <div className="franchise-info">
            <ul className="franchise-benefits">
              {isTagInterest ? (
                <>
                  <li>✅ High demand vehicle safety product</li>
                  <li>✅ Easy onboarding and inventory management</li>
                  <li>✅ Attractive margins for distributors</li>
                  <li>✅ Digital tracking and management system</li>
                </>
              ) : (
                <>
                  <li>✅ Proven business model and operational support</li>
                  <li>✅ Comprehensive marketing and branding materials</li>
                  <li>✅ Detailed training and onboarding process</li>
                  <li>✅ Advanced technology platform for management</li>
                </>
              )}
            </ul>
            <button className="btn-primary" onClick={() => setShowForm(true)}>
              Apply Now
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="franchise-form">
            
            <div className="form-group">
              <label>I am interested in *</label>
              <select 
                name="interest" 
                value={formData.interest} 
                onChange={handleChange}
                className="form-input"
              >
                <option value="tags">Tag Distributor (Reseller)</option>
                <option value="restaurant">Restaurant / Business Franchise</option>
                
              </select>
            </div>

            <div className="form-group">
              <label>Full Name *</label>
              <input 
                type="text" 
                name="name" 
                value={formData.name} 
                onChange={handleChange} 
                required 
                placeholder="Enter your full name"
                className="form-input"
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Email Address *</label>
                <input 
                  type="email" 
                  name="email" 
                  value={formData.email} 
                  onChange={handleChange} 
                  required 
                  placeholder="name@example.com"
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label>Phone Number *</label>
                <input 
                  type="tel" 
                  name="phone" 
                  value={formData.phone} 
                  onChange={handleChange} 
                  required 
                  placeholder="Your contact number"
                  maxLength={10}
                  pattern="[0-9]{10}"
                  inputMode="numeric"
                  className="form-input"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Business Name *</label>
              <input 
                type="text" 
                name="businessName" 
                value={formData.businessName} 
                onChange={handleChange} 
                required 
                placeholder="Proposed business name"
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label>Address *</label>
              <input 
                type="text" 
                name="address" 
                value={formData.address} 
                onChange={handleChange} 
                required 
                placeholder="Street, Building, Area"
                className="form-input"
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Village Name</label>
                <input 
                  type="text" 
                  name="village_name" 
                  value={formData.village_name} 
                  onChange={handleChange} 
                  placeholder="Village name"
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label>Mandal Name *</label>
                <input 
                  type="text" 
                  name="mandal_name" 
                  value={formData.mandal_name} 
                  onChange={handleChange} 
                  required
                  placeholder="Mandal name (duplicates allowed)"
                  className="form-input"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>City Name *</label>
                <input 
                  type="text" 
                  name="city_name" 
                  value={formData.city_name} 
                  onChange={handleChange} 
                  required 
                  placeholder="City"
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label>State *</label>
                <input 
                  type="text" 
                  name="state" 
                  value={formData.state} 
                  onChange={handleChange} 
                  required 
                  placeholder="State"
                  className="form-input"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Pincode *</label>
                <input 
                  type="text" 
                  name="pincode" 
                  value={formData.pincode} 
                  onChange={handleChange} 
                  required 
                  placeholder="6-digit pincode"
                  maxLength={6}
                  pattern="[0-9]{6}"
                  inputMode="numeric"
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label>Location (Optional - legacy)</label>
                <input 
                  type="text" 
                  name="location" 
                  value={formData.location} 
                  onChange={handleChange} 
                  placeholder="City, State (if different)"
                  className="form-input"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Message (Optional)</label>
              <textarea 
                name="message" 
                value={formData.message} 
                onChange={handleChange} 
                rows="4"
                placeholder="Tell us about your business experience..."
                className="form-input"
              ></textarea>
            </div>

            <div className="form-actions">
              <button 
                type="button" 
                className="btn-secondary" 
                onClick={() => setShowForm(false)}
                disabled={loading}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="btn-primary"
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Submit Application'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}

export default Franchise


